import React, {lazy, Suspense} from 'react'
import t from 'format-message'
import {useParams, useSearchParams} from 'react-router'
import {useDocumentTitle} from '../common/lib/useDocumentTitle'

const Grade = lazy(() => import('./components/pages/Grade').then(({Grade}) => ({default: Grade})))

export function GradePage() {
  const {activeAssignmentId, activeParticipantSessionId} = useParams()
  const [searchParams] = useSearchParams()

  const renderBackLink = searchParams.get('renderBackLink')
  const gradeByQuestionEnabled = sessionGradeByQuestionEnabled(
    searchParams.get('gradeByQuestionEnabled'),
  )

  useDocumentTitle(t('Grade'))

  return (
    <Suspense>
      <Grade
        activeAssignmentId={activeAssignmentId}
        activeParticipantSessionId={activeParticipantSessionId}
        renderBackLink={renderBackLink}
        gradeByQuestionEnabled={gradeByQuestionEnabled}
      />
    </Suspense>
  )
}

/**
 * @type {import('react-router').RouteObject[]}
 * @description The routes for the grading module.
 */
export const gradingRoutes = [
  {
    index: true,
    element: <GradePage />,
  },
]

const sessionGradeByQuestionEnabled = queryParam => {
  if (queryParam) {
    return JSON.parse(queryParam)
  }

  return null
}
